import { render, staticRenderFns } from "./merchandiser_home.vue?vue&type=template&id=0a9d7bc8"
import script from "./merchandiser_home.vue?vue&type=script&lang=js"
export * from "./merchandiser_home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports